export const name = 'clickHandlerRegistrar' as const
export const LinkClickHandlersProvider = Symbol('LinkClickHandlersProvider')
